<template>
    <section class="ccard imp-card" aria-labelledby="imp-title">
        <div class="ccard-head">
            <img src="/images/pistes-amelioration.png" alt="" class="masc">
            <h2 class="ccard-title" id="imp-title">Pistes d'amélioration</h2>
        </div>
        <p class="ccard-sub">Un clic applique la modification, et rien n'est définitif.</p>
        <div class="ccard-body">
            <div role="status" :class="{ 'imp-histo': historyCount }">
                <template v-if="historyCount">
                    <p><b>{{ historyCount }} modification{{ historyCount > 1 ? 's' : '' }} appliquée{{ historyCount > 1 ? 's' : '' }}</b> depuis la recette de départ.</p>
                    <div class="acts">
                        <button type="button" class="imp-hbtn ghost" :disabled="busy" @click="$emit('undo')">Annuler la dernière</button>
                        <button type="button" class="imp-hbtn" :disabled="busy" @click="$emit('reset')">Recette de départ</button>
                    </div>
                </template>
            </div>
            <p v-if="!tips.length" class="imp-empty">Aucune piste pour cette recette.</p>
            <div v-else class="imp-list">
                <button v-for="(tip, k) in tips" :key="tip.id" type="button" class="imp-tip" :disabled="busy" @click="$emit('apply', tip)">
                    <span class="n">{{ k + 1 }}</span>
                    <span class="txt"><b>{{ tip.title }}</b><span v-if="tip.description" class="d">{{ tip.description }}</span></span>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'ImprovementTipsCard',
    props: {
        tips: {type: Array, default: () => []},
        historyCount: {type: Number, default: 0},
        busy: {type: Boolean, default: false},
    },
};
</script>
